import React, {useRef, useState} from "react";
import IconButton from "@/app/components/icon_button";
import Image from "@/app/components/image";
import Space, {spaceSizes} from "@/app/components/Space";
import styles from "./styles.module.scss";
import {Assets} from "@/app/utils/assets";
import classNames from "classnames";
import NewCustomCssTransition from "@/app/components/new_custom_css_transition/widget";

interface ChatInputProps {
  textareaRef: React.RefObject<HTMLTextAreaElement>;
  send: (ref: React.RefObject<HTMLTextAreaElement>) => void;
  onFilesSelected?: (files: File[]) => void;
  filesCount?: number;
  hasSending?: boolean;
  buttons?: React.ReactNode
  leftButton?: React.ReactNode
}

const ChatInput: React.FC<ChatInputProps> = ({
                                               textareaRef,
                                               send,
                                               onFilesSelected,
                                               filesCount,
                                               hasSending = false,
                                               buttons,
                                               leftButton
                                             }) => {
  const fileInputRef = useRef<HTMLInputElement>(null);
  const [showButtons, setShowButtons] = useState(true);

  const handleInput = () => {
    if (textareaRef.current) {
      textareaRef.current.style.height = "auto";
      const newHeight = textareaRef.current.scrollHeight;
      const computedStyle = getComputedStyle(textareaRef.current);
      let lineHeight = parseFloat(computedStyle.lineHeight);
      if (isNaN(lineHeight)) {
        const fontSize = parseFloat(computedStyle.fontSize);
        lineHeight = fontSize * 1.2;
      }
      const maxHeight = lineHeight * 4;
      if (Math.min(newHeight, maxHeight) <= 30) return;
      textareaRef.current.style.height = `${Math.min(newHeight, maxHeight)}px`;
    }
  };

  const handlePaperClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const handleFilesChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && onFilesSelected) {
      const filesArray = Array.from(e.target.files);
      onFilesSelected(filesArray);
      e.target.value = "";
    }
  };

  return (
    <div className={styles.footerWrapper}>
      {buttons && <NewCustomCssTransition bool={showButtons}>
        {showButtons ? (<div className={styles.buttons}>{buttons}</div>) : null}
      </NewCustomCssTransition>}
      <div className={styles.footerInner}>
        {leftButton && leftButton}
        <div className={styles.inputWrapper}>
          <div className={styles.iconWrapper} onClick={handlePaperClick}>
            {(filesCount ?? 0) > 0 && <div className={styles.filesCount}>{filesCount}</div>}
            <IconButton asset={Assets.paperclip}/>
          </div>
          <input
            type="file"
            ref={fileInputRef}
            style={{display: "none"}}
            multiple
            accept="image/png, image/webp, image/jpeg, image/jpg, application/pdf"
            onChange={handleFilesChange}
          />
          <Space w={spaceSizes.s16}/>
          <textarea
            ref={textareaRef}
            className={styles.input}
            rows={1}
            onInput={handleInput}
          />
          <Space w={spaceSizes.s16}/>
          <NewCustomCssTransition bool={buttons === undefined}>
            {buttons === undefined ? <IconButton asset={Assets.smallMicrophone}/> :
              showButtons ? <IconButton asset={Assets.unshowButtons} onClick={() => setShowButtons(false)}/> :
                <IconButton asset={Assets.showButtons} onClick={() => setShowButtons(true)}/>}
          </NewCustomCssTransition>
        </div>
        <div className={classNames(styles.sendButton, {[styles.sending]: hasSending})}
             onClick={() => send(textareaRef)}>
          {!hasSending ? (
            <Image asset={Assets.send}/>
          ) : <div className={styles.spinner}></div>}
        </div>
      </div>
    </div>

  )
    ;
};

export default ChatInput;